import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { doDoorKnock, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V7EmilyCarWashAfter } from "./V7";

export const V7EmilyCarWash = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V7AnnPureOrHate`)) {
        doWaitImageByTime(images.v7.V7RoomEmilyBeforeCarWash_1);
        doDoorKnock();
        mc.talk(`Come in!`, { method: "Shouting" });
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_2);
        emily.talk(`Have you been in your room all day?`);
        mc.talk(`Yes...it's a slow day.`);
        mc.talk(`And since when did you start knocking?`);
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_3);
        emily.talk(`I don't know what you might be doing when your door is closed...`);
        if (mc.properties.annStatus === "gf") {
            mc.talk(`That's never stopped you before from rushing in.`);
            emily.talk(`You have a girlfriend now... Your hormones must be going crazy.`);
        } else {

        }
        mc.talk(`...`);
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_3.partials.V7RoomEmilyBeforeCarWash_3_p);
        emily.talk(`Anyway!`);
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_3);
        emily.talk(`Since you said it's a slow day, I was wondering if you want to join me.`);
        mc.talk(`Where to this time?`);
        emily.talk(`It's close.`);
        emily.talk(`I'm about to wash my car and I could use the company...`);
        mc.talk(`That explains the attire.`);
        mc.talk(`Is it smart wearing a white T-shirt when you are obviously going to get wet?`);
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_4);
        emily.talk(`That's why I have a bikini underneath silly!`);
        mc.talk(`Yeah...`);
        mc.talk(`Well, let me check a few things and I'll join you.`);
        ImageClass.setImage(images.v7.V7RoomEmilyBeforeCarWash_3);
        emily.talk(`Great! I'll be waiting.`);
        doTransition(images.v7.EmilyCarWash_7);

    } else {
        ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1.2, wait: 1.2, hideText: true });
        ImageClass.setImage(images.v7.EmilyCarWash_0, { duration: 1, wait: 1 });
        mc.think(`Is that Emily... Washing her car?`);
        ImageClass.setImage(images.v7.EmilyCarWash_1);
        mc.think(`Honesty, her car was so clean I didn't think it needed washing.`);
        ImageClass.setImage(images.v7.EmilyCarWash_2);
        mc.think(`Maybe she is looking for ways to pass her time.`);
        if (mc.properties.emilyRelationship > 5) {
            mc.think(`People would pay good money to have her washing their cars like that...`);
            mc.think(`Lord knows I would.`);

        } else {

        }
    }

    mc.talk(`Hey Emily.`);
    ImageClass.setImage({ ...images.v7.EmilyCarWash_10, partialsToDisplay: [images.v7.EmilyCarWash_10.partials.EmilyCarWash_10_p] });
    if (Game.seenScenarios.includes(`V7AnnPureOrHate`)) {
        emily.talk(`Took you long enough!`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`Sorry... I got a bit carried away.`);
        mc.talk(`I totally forgot to ask if you need any help.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10.partials.EmilyCarWash_10_p);
        emily.talk(`No, I'm fine.`);
        emily.talk(`Besides, if I make you work, you won't come next time.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`True...`);



    } else {

        emily.talk(`${mc.name}! You are back.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`Yeah, I see you found a way to keep yourself busy.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10.partials.EmilyCarWash_10_p);
        emily.talk(`Haha, yeah. I was bored when I got back and saw that my car could use a quick wash.`);
        emily.talk(`So here I am!`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`Really? It was clean the last time I saw it.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10.partials.EmilyCarWash_10_p);
        emily.talk(`You know how it is with new cars... You always want them squeaky clean.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`True.`);
        mc.talk(`Do you need help?`);
        ImageClass.setImage(images.v7.EmilyCarWash_10.partials.EmilyCarWash_10_p);
        emily.talk(`No, I'm fine, but I'd love to have some company.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        mc.talk(`Sure!`);
        emily.talk(`I knew I could count on you!`);
    }

    ImageClass.setImage(images.v7.EmilyCarWash_7, { duration: 1 });
    await emily.setQuestion(new Question({ text: `So I wanted to ask you something.`, options: { think: false }, key: `v7EmilyCarWashLookedCloser` })
        .option({ title: `Look closer`, key: true })
        .option({ title: `Don't look`, key: false }));


    if (Question.globalAnswers.v7EmilyCarWashLookedCloser) {
        ImageClass.setImage(images.v7.EmilyCarWash_8);
        await mc.setQuestion(new Question({ text: `She is...`, options: { think: true }, key: `v7EmilyCarWashThoughtEmilyIsHot` })
            .option({ title: `So hot`, key: true })
            .option({ title: `Just my ${emily.properties.relation}`, key: false }));


        if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
            mc.think(`Emily is so hot... I can't believe she is my ${emily.properties.relation}.`);
            mc.think(`I know it's wrong but I just can't... Get over it.`);


        } else {
            mc.think(`She is just my ${emily.properties.relation}!`);

        }
        ImageClass.setImage(images.v7.EmilyCarWash_5, { duration: 0, shake: true });
        emily.talk(`Hello!!! Are you listening to me?`);
        mc.talk(`Yes, of course. Sorry.`);
        emily.talk(`I'll ask again but you don't have to answer if you don't want to.`);

    } else {

        mc.talk(`Sure, what is it?`);
        emily.talk(`Ok, but you don't have to answer if you don't want to.`);
    }
    mc.talk(`I don't have anything to hide from you.`);

    if (Game.seenScenarios.includes(`V7VanessaMorning`)) {
        ImageClass.setImage(images.v7.EmilyCarWash_9, { duration: 1 });
        emily.talk(`Well, it's about that girl, Vanessa.`);
        emily.talk(`I know she is Joey's girlfriend and yet you spend so much time with her.`);
        ImageClass.setImage(images.v7.EmilyCarWash_7);
        emily.talk(`Is Joey ok with that?`);
        ImageClass.setImage(images.v7.EmilyCarWash_16);
        if (mc.properties.joeStatus !== "enemy") {
            mc.talk(`He is. He definitely would've said something if he wasn't.`);

        } else {
            // TODO:

        }
        if (mc.properties.annStatus === "gf") {
            emily.talk(`And your girlfriend? Remind me her name again?`);
            mc.talk(`Ann.`);
            emily.talk(`Right!`);
            emily.talk(`What does she have to say about that?`);
            mc.talk(`Well, Vanessa is the only reason I know Ann in the first place.`);

        } else {
            // TODO: if not on Vanessa's path -> some other dialogs
        }

        ImageClass.setImage(images.v7.EmilyCarWash_5);
        emily.talk(`I think you should talk to him...`);
        emily.talk(`You know, just to make sure.`);
        mc.talk(`To be honest, I never thought about that.`);
        emily.talk(`You should...`);
        ImageClass.setImage(images.v7.EmilyCarWash_16, { duration: 1 });
        mc.talk(`Ok.`);
        emily.talk(`Don't think that I'm judging you or anything. You know how I like to be involved with your life.`);
        emily.talk(`And now that I'm back, I feel like there is a lot of catching up to do.`);
        mc.talk(`I get it! No worries.`);


    } else {
        // TODO: if not on Vanessa's path (Ann hate Joey hate Ann corruption)
        if (mc.properties.annStatus === "gf") {

            emily.talk(`So how are things with that girl of yours.`);
            mc.talk(`Ann?`);
            emily.talk(`Yeah.`);
            mc.talk(`It's fine I guess, nothing too crazy.`);
            emily.talk(`You sure?`);
            if (ann.properties.isCorrupted) {
                ImageClass.setImage(images.v7.EmilyCarWash_7);
                mc.talk(`She is trying all these new stuff right now and I'm kinda along for the ride.`);
                emily.talk(`What stuff?`);
                mc.talk(`Initially she wanted to become a doctor, but now she wants to be an actress.`);
                emily.talk(`Wow, that's a huge jump from one thing to another.`);
                ImageClass.setImage(images.v7.EmilyCarWash_16);
                mc.talk(`That's what I said, but I guess she is not happy with the path she is taking in life.`);
                mc.talk(`Or wants to take per se.`);
                emily.talk(`Oh, I understand.`);
                ImageClass.setImage(images.v7.EmilyCarWash_9);
                emily.talk(`So how is the actress gig going for her?`);
                mc.talk(`It's really new, she just told me about it! I don't even know if she'll go through with it or not.`);
                mc.talk(`We actually went to see an audition yesterday... It was a mess.`);
                ImageClass.setImage(images.v7.EmilyCarWash_10);
                emily.talk(`You? At an audition? Haha.`);
                mc.talk(`Yeah...`);
                emily.talk(`Good luck to her, I guess.`);

            } else {
                ImageClass.setImage(images.v7.EmilyCarWash_7);
                mc.talk(`Yeah... I'm in a relationship with a girl that prefers books over me.`);
                emily.talk(`Don't say that!`);
                mc.talk(`It's true though.\nShe keeps studying instead of meeting me.`);
                emily.talk(`Isn't school over?`);
                mc.talk(`It is, but she is studying for medical college or something.`);
                ImageClass.setImage(images.v7.EmilyCarWash_16);
                emily.talk(`Oh wow, that is impressive!`);
                emily.talk(`She will achieve great things, you should hold on to that one.`);
                emily.talk(`And I'm sure she'll find time for you soon!`);
                ImageClass.setImage(images.v7.EmilyCarWash_9);
                emily.talk(`She's stupid if she doesn't.`);
                mc.talk(`Well, she said she wants to talk about something in person.`);
                ImageClass.setImage(images.v7.EmilyCarWash_5);
                emily.talk(`Uh no, that can't be good.`);
                emily.talk(`If a girl has something to say and she doesn't say it over the phone that means you are screwed.`);
                mc.talk(`But I haven't done anything wrong.`);
                ImageClass.setImage(images.v7.EmilyCarWash_10);
                emily.talk(`That's what you all think. Haha.`);
                mc.talk(`Well... We'll see what happens.`);
            }
        } else {
            ImageClass.setImage(images.v7.EmilyCarWash_5);
            emily.talk(`I was wondering why you aren't dating anyone.`);
            mc.talk(`Who said I wasn't?`);
            ImageClass.setImage(images.v7.EmilyCarWash_9);
            emily.talk(`I don't know... I haven't seen any girl coming over except for Joey's girlfriend. `);
            if (mc.properties.hasJennysNumber) {
                mc.talk(`I actually met someone not long ago.`);
                ImageClass.setImage(images.v7.EmilyCarWash_10);
                emily.talk(`Really?!`);
                mc.talk(`Yes, we texted a bit.`);
                emily.talk(`So what are you waiting for? Ask her out!`);
                mc.talk(`I might!`);

            } else {
                emily.talk(`Doesn't she have any friends she can hook you up with?`);
                mc.talk(`Actually, she tried that... But it didn't work out.`);
                ImageClass.setImage(images.v7.EmilyCarWash_5);
                emily.talk(`Why?`);
                mc.talk(`I told her I don't like her and that was about it.`);
                emily.talk(`Well... There isn't much you can do if the attraction is not there.`);
                mc.talk(`Yup.`);

            }
            ImageClass.setImage(images.v7.EmilyCarWash_16);
            mc.talk(`Why do you suddenly care so much if I'm dating someone anyway?`);
            ImageClass.setImage(images.v7.EmilyCarWash_7);
            emily.talk(`Because I saw someone really cute on my way back home...`);
            ImageClass.setImage(images.v7.EmilyCarWash_5);
            emily.talk(`To be honest, cute is an understatement.`);
            mc.talk(`And...?`);
            ImageClass.setImage(images.v7.EmilyCarWash_9);
            emily.talk(`If you'll stay with me until I'm done I'll tell you where she is!`);
            mc.talk(`Are you blackmailing me?`);
            ImageClass.setImage(images.v7.EmilyCarWash_10);
            emily.talk(`Haha... You know I'm just yanking your chain... You can leave when you want.`);
            mc.talk(`The only reason I came was to keep you company, of course I'll stay.`);
            ImageClass.setImage(images.v7.EmilyCarWash_5);
            emily.talk(`Thank you!`);

        }


    }


    return jump(V7EmilyCarWash2, "V7EmilyCarWash2");
};

export const V7EmilyCarWash2 = async (): Promise<any> => {
    mc.talk(`What about you? Where have you been?`);
    ImageClass.setImage(images.v7.EmilyCarWash_5, { duration: 1 });
    emily.talk(`I was driving around looking for a job.`);
    emily.talk(`You know I like to spend a lot of money... I can't afford staying unemployed for so long.`);
    mc.talk(`Yeah, if there is money around I can count on you to make it disappear.`);
    emily.talk(`Haha! Exactly!`);

    if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
        emily.talk(`You are really sweating by the way.`);
        mc.think(`I wonder why...`);
        emily.talk(`You know that you can sit in the car right?`);
        emily.talk(`The air condition is great!`);
        emily.talk(`That's one of the reasons why I love this car so much!`);

    } else {

        emily.talk(`By the way, you don't have to stand in the sun. Sit inside the car and start the air condition.`);
        mc.talk(`Thanks, it's really hot.`);
        ImageClass.setImage(images.v7.EmilyCarWash_10);
        emily.talk(`Sorry for not mentioning it right away.`);
    }

    ImageClass.setImage(images.v7.EmilyCarWash_3, { duration: 1.5 });
    emily.talk(`Well?`, { method: "Slightly Shouting" });
    mc.talk(`You are right. That's much better.`, { method: "Slightly Shouting" });
    emily.talk(`Told you!`, { method: "Slightly Shouting" });
    ImageClass.setImage(images.v7.EmilyCarWash_6);
    emily.talk(`I'm almost done anyway!`, { method: "Shouting" });
    if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
        mc.think(`It's getting hot in here too...`);
    }


    mc.talk(`Have you found something?`, { method: "Shouting" });
    emily.talk(`WHAT?`, { method: "Shouting" });
    mc.talk(`The job. You were just saying you are looking for one.`, { method: "Shouting" });
    emily.talk(`Oh right!`, { method: "Shouting" });
    ImageClass.setImage(images.v7.EmilyCarWash_17, { duration: 1 });
    emily.talk(`Well, not really...`, { method: "Slightly Shouting" });
    mc.talk(`What kind of job are you looking for?`, { method: "Slightly Shouting" });
    emily.talk(`Anything really. You know me, if it has a paycheck I'd do it!`, { method: "Slightly Shouting" });
    emily.talk(`I was about to ask you if you know something but you are unemployed yourself.`, { method: "Shouting" });
    mc.talk(`I can ask around.`, { method: "Shouting" });
    emily.talk(`Thank you! I appreciate it!`, { method: "Shouting" });

    ImageClass.setImage(images.v7.EmilyCarWash_3);
    emily.talk(`Maybe they'll have two spots and we could work together. It's time for you to get up off your fat ass! Haha.`, { method: "Slightly Shouting" });
    mc.talk(`Maybe... I can't say it's not nice doing nothing.`, { method: "Slightly Shouting" });
    emily.talk(`True, but you better change you mindset before it will be too late.`, { method: "Slightly Shouting" });
    emily.talk(`It's either work or go study something and get a degree.`, { method: "Slightly Shouting" });
    ImageClass.setImage(images.v7.EmilyCarWash_6, { duration: 1 });
    mc.talk(`Yes Mom.`, { method: "Shouting" });
    emily.talk(`Haha, you know I just want what's best for you.`, { method: "Shouting" });
    mc.talk(`I know I'm just kidding.`, { method: "Shouting" });

    // emily.talk(`By the way, you don't have to stand in the sun. Sit inside the car and start the air condition.`);
    // mc.talk(`Thanks, it's really hot.`);
    // emily.talk(`Sorry for not mentioning it before.`);

    // emily.talk(`Well?`);
    // mc.talk(`You are right. That's much better.`);
    // emily.talk(`I'm almost done anyway!`);

    mc.talk(`You know. When I helped Joey wash his car I don't remember getting that soapy.`, { method: "Shouting" });
    emily.talk(`Hey! Don't make fun of me!`, { method: "Shouting" });
    mc.talk(`Haha, I didn't.`, { method: "Shouting" });
    ImageClass.setImage(images.v7.EmilyCarWash_4, { duration: 1 });
    emily.talk(`I guess it's just a hobby from my college days.`, { method: "Slightly Shouting" });
    emily.talk(`A bunch of us girls used to wash cars like this.`, { method: "Slightly Shouting" });
    emily.talk(`You won't believe me but it's actually good money!`, { method: "Slightly Shouting" });
    mc.talk(`I bet.`, { method: "Slightly Shouting" });

    emily.talk(`And maybe next time you can show me how to wash the car in jeans and a T-shirt.`, { method: "Slightly Shouting" });
    mc.talk(`Nah, I'm good sitting here and making comments.`, { method: "Slightly Shouting" });
    emily.talk(`I bet!`, { method: "Slightly Shouting" });
    // 

    return jump(V7EmilyCarWash3, "V7EmilyCarWash3");
};
export const V7EmilyCarWash3 = async (): Promise<any> => {

    emily.talk(`FUCK!`, { method: "Slightly Shouting" });
    mc.talk(`What happened?`, { method: "Slightly Shouting" });
    emily.talk(`I can't reach the middle of the roof.`, { method: "Slightly Shouting" });
    emily.talk(`Can you help me?`, { method: "Slightly Shouting" });
    mc.talk(`Of course.`, { method: "Slightly Shouting" });
    ImageClass.setImage(images.v7.EmilyCarWash_5, { duration: 1 });
    mc.talk(`Give me the sponge, I'll do it.`);
    emily.talk(`Don't be silly, I don't want you to get your clothes wet.`);
    emily.talk(`Just lift me up.`);
    mc.talk(`Seriously?`);
    emily.talk(`Yes, just like when we were kids.`);
    ImageClass.setImage(images.v7.EmilyCarWash_11, { duration: 1 });
    emily.talk(`Don't worry! I'm not heavy!`);
    mc.talk(`Alright, get ready.`);
    ImageClass.setImage(images.v7.EmilyCarWash_12, { duration: 1 });
    emily.talk(`Are you holding on tight?`);
    if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
        mc.think(`Not as tight as I want...`);

    } else {

    }


    mc.talk(`Yes, go for it.`);
    ImageClass.setImage(images.v7.EmilyCarWash_13);
    emily.talk(`Finally!`);
    emily.talk(`If you hadn't shown up I'd have had to get a chair from the house.`);
    emily.talk(`Almost done! How are you holding up?`);
    ImageClass.setImage(images.v7.EmilyCarWash_14);
    if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
        mc.talk(`Something's up.`);
        emily.talk(`What was that?`);
        mc.talk(`I said I am holding up.`);

    } else {

        mc.talk(`I'm good, take your time.`);
    }
    emily.talk(`Even though it's fun being up here... I'm almost...`);
    ImageClass.setImage(images.v7.EmilyCarWash_15);
    emily.talk(`Done!`);
    ImageClass.setImage(images.v7.EmilyCarWash_15.partials.EmilyCarWash_15_p);
    mc.talk(`Great!`);
    ImageClass.setImage(images.v7.EmilyCarWash_15);
    emily.talk(`Thank you so much for the help!`);


    // ImageClass.setImage(images.IMAGE)

    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v7.EmilyCarWash_15, { duration: 1 });
        emily.talk(`Oh! I almost forgot to tell you!`);
        emily.talk(`We have a new neighbor.`);
        emily.talk(`I saw her on my way back. She is just unpacking the moving truck.`);
        emily.talk(`She looks really good...`);
        emily.talk(`If you didn't have a girlfriend I'd say go and say hey...`);
        ImageClass.setImage(images.v7.EmilyCarWash_15.partials.EmilyCarWash_15_p);
        mc.talk(`There is no harm in being friendly.`);
        ImageClass.setImage(images.v7.EmilyCarWash_15);
        emily.talk(`Right.`);
        emily.talk(`Have fun! I'll go wash myself.`);

    } else {
        ImageClass.setImage(images.v7.EmilyCarWash_15, { duration: 1 });
        mc.talk(`Ah-am!`);
        ImageClass.setImage(images.v7.EmilyCarWash_15.partials.EmilyCarWash_15_p, { duration: 1 });
        emily.talk(`What?`);
        mc.talk(`Didn't you mentioned something about a cute girl?`);
        ImageClass.setImage(images.v7.EmilyCarWash_15);
        emily.talk(`Oh my! I can't believe I almost forgot. Haha.`);
        emily.talk(`Just go down the street and you'll see her, I imagine by now she is almost done unpacking the moving truck.`);

        emily.talk(`But I bet she's still there. You should go and introduce yourself!`);
        ImageClass.setImage(images.v7.EmilyCarWash_15.partials.EmilyCarWash_15_p);
        mc.talk(`Sounds like a great idea.`);
        ImageClass.setImage(images.v7.EmilyCarWash_15);
        emily.talk(`And I'll go wash myself!`);
    }
    return jump(V7EmilyCarWashAfter, "V7EmilyCarWashAfter");
};